import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOCATIONS = [
  { name: 'Florida', path: '/florida' },
  { name: 'Orlando, FL', path: '/orlando' },
  { name: 'New York', path: '/new-york' },
];

const PinIcon: React.FC = () => (
  <svg
    className="locations_we_serve_icon"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

// Shown on every location landing page (Florida, Orlando, New York), so visitors can jump
// to the other cities SLAMMMM serves. The page you're already on doesn't get its own button.
const LocationsWeServe: React.FC = () => {
  const { pathname } = useLocation();
  const locations = LOCATIONS.filter((loc) => loc.path !== pathname);

  return (
    <section className="py-5 bg-light locations_we_serve_section">
      <div className="container">
        <h2 className="text-center locations_we_serve_title">Locations we serve</h2>
        <div className="locations_we_serve_grid">
          {locations.map((loc) => (
            <Link key={loc.path} to={loc.path} className="locations_we_serve_pill">
              <PinIcon />
              <span>{loc.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsWeServe;
